var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 99,
    viewBox: "0 0 98 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_3_1722)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 49,
    cy: 49.0546,
    rx: 33,
    ry: 33.0546,
    fill: "#030316"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.7558 44.3861C64.5267 42.6123 63.7192 40.5406 62.7558 39.5331L58.5058 35.2761C56.7208 33.5023 54.6667 34.3111 53.6608 35.2761L51.2525 37.7026H47.5833C44.8917 37.7026 43.3333 39.1216 42.54 40.7534L36.25 47.0538V52.7299L35.2442 53.7232C33.4733 55.5111 34.2808 57.5687 35.2442 58.5762L39.4942 62.8332C40.2592 63.5995 41.0808 63.8833 41.86 63.8833C42.8658 63.8833 43.7867 63.3866 44.3392 62.8332L48.1642 58.9877H53.25C55.6583 58.9877 56.8767 57.4836 57.3158 56.0078C58.9167 55.5821 59.795 54.3617 60.1492 53.1698C62.345 52.6022 63.1667 50.5162 63.1667 49.0546V44.7976H62.3308L62.7558 44.3861ZM60.3333 49.0546C60.3333 49.6932 60.0642 50.4736 58.9167 50.4736H57.5V51.8927C57.5 52.5312 57.2308 53.3117 56.0833 53.3117H54.6667V54.7307C54.6667 55.3692 54.3975 56.1497 53.25 56.1497H47.0025L42.3558 60.804C41.9167 61.2156 41.6617 60.9743 41.5058 60.8182L37.27 56.5896C36.8592 56.1497 37.1 55.8943 37.2558 55.7382L39.0833 53.8935V48.2174L41.9167 45.3794V47.6356C41.9167 49.3526 43.05 51.8927 46.1667 51.8927C49.2833 51.8927 50.4167 49.3526 50.4167 47.6356H60.3333V49.0546ZM60.7442 42.3711L58.3358 44.7976H47.5833V47.6356C47.5833 48.2742 47.3142 49.0546 46.1667 49.0546C45.0192 49.0546 44.75 48.2742 44.75 47.6356V43.3786C44.75 42.7259 44.9908 40.5406 47.5833 40.5406H52.4142L55.6442 37.3052C56.0833 36.8937 56.3383 37.135 56.4942 37.291L60.73 41.5197C61.1408 41.9596 60.9 42.215 60.7442 42.3711Z",
    fill: "#7417E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_3_1722",
    x: 0,
    y: 0,
    width: 98,
    height: 98.1091,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.105882 0 0 0 0 0.568627 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_1722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.105882 0 0 0 0 0.568627 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3_1722",
    result: "effect2_dropShadow_3_1722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.105882 0 0 0 0 0.568627 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_3_1722",
    result: "effect3_dropShadow_3_1722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.105882 0 0 0 0 0.568627 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_3_1722",
    result: "effect4_dropShadow_3_1722"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_3_1722",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS4);
export default __webpack_public_path__ + "static/media/s4.5c074bf5d339699623edf69934310d36.svg";
export { ForwardRef as ReactComponent };